import React from "react";
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';

const Details = () => {
  return (
      <div>
        <Bar/>
          <div className="breadcrumbs">
            <div className="container">
              <div className="d-flex justify-content-between align-items-center">
                <h2>Playstation Cafe - 8M</h2>
                <ol>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>Project Details</li>
                </ol>
              </div>
            </div>
          </div>
          {/* End Breadcrumbs */}
          {/* ======= Portfolio Details Section ======= */}
          <section id="portfolio-details" className="portfolio-details">
            <div className="container" data-aos="fade-up">
              <div className="row gy-4">
                <div className="col-lg-8">
                  <div className="portfolio-details-slider swiper">
                    <div className="swiper-wrapper align-items-center">
                      <div className="swiper-slide">
                        <img src="https://www.dekorcenneti.com/galeri/playstation%20cafe%20dekorasyon%20ornekleri%20(9).jpg" alt="" />
                      </div>
                      <div className="swiper-slide">
                        <img src="https://www.dekorcenneti.com/galeri/playstation%20cafe%20dekorasyon%20ornekleri%20(10).jpg" alt="" />
                      </div>
                      <div className="swiper-slide">
                        <img src="https://avatars.mds.yandex.net/get-altay/2930751/2a000001740c2eb913bc0000d6bf56ed2822/XXXL" alt="" />
                      </div>
                      <div className="swiper-slide">
                        <img src="https://www.dekorcenneti.com/galeri/playstation%20cafe%20dekorasyon%20ornekleri%20(16).jpg" alt="" />
                      </div>
                      <div className="swiper-slide">
                        <img src="https://avatars.mds.yandex.net/get-altay/2786941/2a000001740700e60c85949d6dcf3a2ee84e/XXXL" alt="" />
                      </div>
                    </div>
                    <div className="swiper-pagination" />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="portfolio-info">
                    <h3>Project information</h3>
                    <ul>
                      <li>
                        <strong>Category</strong>: Small Project
                      </li>
                      <li>
                        <strong>Cost of Project</strong>: 8,000,000 SYP
                      </li>
                      <li>
                        <strong>Project date</strong>: 01 March, 2020
                      </li>
                      <li>
                        <strong>Project Place</strong>: Under Ground floor
                      </li>
                    </ul>
                  </div>
                  <div className="portfolio-description">
                    <h2>Project Requirements</h2>
                    <p style={{textAlign: "center"}}>
                      <p><strong>Playstation 4</strong>______________Required Number : 3</p>
                      <p><strong>LCD TV</strong><span></span>_____________________Required Number : 3</p>
                      <p><strong>Computer Desktop</strong>________Required Number : 4</p>
                      <p><strong>Internet</strong>___________________Required Speed:8 MB</p>
                    </p>
                  </div>
                  <div className="portfolio-description">
                    <h2>Project Requirements Price</h2>
                    <p style={{textAlign: "center"}}>
                      <p><strong>Playstation 4</strong>____________Required Price : 1,000,000 SYP</p>
                      <p><strong>LCD TV</strong><span></span>____________________Required Price : 900,000 SYP</p>
                      <p><strong>Computer Desktop</strong>_____Required Price : 1,500,000 SYP </p>
                      <p><strong>Internet</strong>____________________Required Price : 21,000 SYP</p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        <Footer/>
      </div>
  );
};

export default Details;